import React from 'react';

import IconClose from '../../../assets/icons/IconClose';
import { clsx } from '../../../utils/helper';

const ModalHeader = ({ children, titleLeft, onClose }) => {
    return (
        <div className={clsx('base-modal-header', titleLeft && 'title-left')}>
            {children}
            <div onClick={onClose} className="button-close">
                <IconClose />
            </div>
        </div>
    );
};

export default ModalHeader;